

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;


export const fetchOrderById = async (orderId) => {
    const token = localStorage.getItem('token'); 
  try {
    const response = await fetch(`${API_BASE_URL}/admin/lead/leads/orders/${orderId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching order by ID:', error);
    throw error;
  }
};